import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel, useStateManager } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AccountSummaryWidget from 'components/pages/AccountSummaryPage/components/AccountSummaryWidget';
import PaymentsWidget from 'components/pages/AccountSummaryPage/components/PaymentsWidget';
import QuickTransferWidget from 'components/pages/AccountSummaryPage/components/QuickTransferWidget';
import { LeftColumnContainer, PageContainer, PageContentView, RightColumnContainer } from 'components/shared';
import ChangeLoginWidget from "components/shared/widgets/ChangeLoginWidget";
import CreditScoreLeftColWidget from "components/shared/widgets/CreditScoreLeftColWidget";
import CreditScoreWidget from 'components/shared/widgets/CreditScoreWidget';
import QuickLinksWidget from "components/shared/widgets/QuickLinksWidget";
import Classes from "model";
import React, { useEffect, useState } from "react";
import AccountSummaryAssetsAndLoansWidget from "./components/AccountSummaryWidget/components/AccountSummaryAssetsAndLoansWidget";
import AccountSummarySortableTableAssetsAndLoansWidget from "./components/AccountSummaryWidget/components/AccountSummarySortableTableAssetsAndLoansWidget";
import AccountSummarySortableTableWidget from "./components/AccountSummaryWidget/components/AccountSummarySortableTableWidget";
import AccountSummarySortableTableWithLinksWidget from "./components/AccountSummaryWidget/components/AccountSummarySortableTableWithLinksWidget";
import ColumnAdWidget from "./components/ColumnAdWidget";
import ManageCardsWidget from "./components/ManageCardsWidget";
import MobileColumnAdWidget from "./components/MobileColumnAdWidget";
import "./mobile.css";
import AlertsWidget from "./components/AlertsWidget";


/**
 * @function AccountSummaryPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AccountSummaryPage
 */

export default function AccountSummaryPage(props) {
  // Initalize globalController for all models that require it in the page
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  let options = useModel().branding.options;
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
  const className = props.className?(" "+props.className):"";

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    forceUpdate: (data, ui) => {
      BCMSStateManagerCRUD.init(state)
        .update([ "data" ], data)
        .update([ "ui" ], ui)
        .submit(setState);
    },
  });

  return (
    <PageContainer className={"account-summary-page"+className} state={ { data, ui } } controller={ controller }>
      <AccountSummaryContent options={ options }/>
    </PageContainer>
  );
}

function AccountSummaryContent(props) {
  let hasPayments = props.options.rxp17_abi22 === "true";
  let hasCreditSense = props.options.cs21_abi22 === "true";
  const { data, ui, forceUpdate } = useStateManager();
  const { branding } = useModel();
  const options = branding.options;
  const rightTopAdURL = options.right_top_ad_url_abi22;
  const rightBottomAdURL = options.right_bottom_ad_url_abi22;
  const leftAdURL = options.left_ad_url;
   const [ isDesktop, setIsDesktop ] = useState(window.innerWidth >= 751);

  // START: Branding for MABI23.
  const mabi23Branding = window.mabi23Branding;
  let _branding = { colors: branding.colors, options: branding.options};

  if(mabi23Branding) {
    _branding = mabi23Branding;
  }
  const hasMabi23TopBannerAd = _branding.options.top_banner_ad_mabi23 === "true" ? true : false;
  const optionMap = (option)=>{
  
  const key = { "left_column_widget_1_abi22": mabi23Branding? "widget_1_mabi23": "left_column_widget_1_abi22",
                "left_column_widget_2_abi22":mabi23Branding? "widget_2_mabi23": "left_column_widget_2_abi22",
                "left_column_widget_3_abi22":mabi23Branding? "widget_3_mabi23": "left_column_widget_3_abi22",
                "right_column_widget_1_abi22":mabi23Branding? "widget_4_mabi23": "right_column_widget_1_abi22",
                "right_column_widget_2_abi22":mabi23Branding? "widget_5_mabi23": "right_column_widget_2_abi22",
                "right_column_widget_3_abi22":mabi23Branding? "widget_6_mabi23": "right_column_widget_3_abi22",
                "right_column_widget_4_abi22":mabi23Branding? "widget_7_mabi23": "right_column_widget_4_abi22",
                "right_column_widget_5_abi22":mabi23Branding? "widget_8_mabi23": "right_column_widget_5_abi22",
                "left_ad_url":mabi23Branding? "top_ad_url_mabi23": "left_ad_url",
                "right_top_ad_url_abi22":mabi23Branding? "ad_1_url_mabi23": "right_top_ad_url_abi22",
                "right_bottom_ad_url_abi22":mabi23Branding? "ad_2_url_mabi23": "right_bottom_ad_url_abi22"
          }
              return _branding.options[key[option]];
  }
  const colorMap = (color)=>{
   
  const key = {
                "left_column_ad_image_abi22":mabi23Branding? _branding.colors["top_banner_image_mabi23"]: "left_column_ad_image_abi22",
                "right_column_ad_top_image_abi22":mabi23Branding?  _branding.colors["ad_1_image_mabi23"]: "right_column_ad_top_image_abi22",
                "right_column_ad_bottom_image_abi22":mabi23Branding?  _branding.colors["ad_2_image_mabi23"]: "right_column_ad_bottom_image_abi22",
                            
               }
              return key[color];
  }
  let    leftWidgets = [];
  let ad =  <div key={ "ad_container" }>
              {  mabi23Branding ?                  
                  <MobileColumnAdWidget key="mobileAd" adImageURL={colorMap("left_column_ad_image_abi22") } adLinkURL={optionMap("left_ad_url")} />
                :<ColumnAdWidget key="ad" brandingColorName={ colorMap("left_column_ad_image_abi22")  } adURL={ optionMap("left_ad_url") }/>
              }
            </div>
let ad_1 =  <div key={ "ad_container" }>
              {  mabi23Branding ?                  
                  <MobileColumnAdWidget key="mobileAd_1" adImageURL={colorMap("right_column_ad_top_image_abi22") } adLinkURL={ optionMap("right_top_ad_url_abi22") } />
                :<ColumnAdWidget key="ad_1" brandingColorName={ colorMap("right_column_ad_top_image_abi22") } adURL={ optionMap("right_top_ad_url_abi22") }/>
              }
            </div>
let ad_2 =  <div key={ "ad_container" }>
               {  mabi23Branding ?                  
                  <MobileColumnAdWidget key="mobileAd_1" adImageURL={colorMap("right_column_ad_bottom_image_abi22") } adLinkURL={ optionMap("right_bottom_ad_url_abi22") } />
                :<ColumnAdWidget key="ad_1" brandingColorName={"right_column_ad_bottom_image_abi22" } adURL={ optionMap("right_bottom_ad_url_abi22") }/>
              }
            </div>           
  let mapLeftWidgets = {
          "None":false,
          "Manage Cards": <ManageCardsWidget key="card_1"/>,
          "Account Summary": <AccountSummaryWidget key="accountSummary_1"/>, 
          "Credit Score": <CreditScoreLeftColWidget  key="creditScore_1" />, 
          "Ad":ad,
          "Ad 1": ad_1,
          "Ad 2": ad_2,
          "Quick Links":<QuickLinksWidget key="quickLinks_1"/>,
         "Account Summary With Sortable Table":
                  <React.Fragment key={ "account_summary_container" }>
                    {!isDesktop &&  <AccountSummaryWidget key="accountSummary_1" className="show-on-mobile" view="mobile"/>}
                    { isDesktop &&  <AccountSummarySortableTableWidget className="show-on-desktop" key="accountSummary_2"/>}
                  </React.Fragment>,
        // An option value in abi22.
         "Account Summary with Sortable Headers grouped by Assets & Loans":
                  <React.Fragment key={ "account_summary_container" }>
                    {!isDesktop &&  <AccountSummaryAssetsAndLoansWidget key="accountSummary_1" className="show-on-mobile" view="mobile"/>}
                    { isDesktop &&  <AccountSummarySortableTableAssetsAndLoansWidget className="show-on-desktop" key="accountSummary_2"/>}
                  </React.Fragment>,
        "Account Summary with Sortable Table and Links":
                  <React.Fragment key={ "account_summary_container" }>
                    {!isDesktop &&  <AccountSummaryAssetsAndLoansWidget key="accountSummary_1" className="show-on-mobile" view="mobile"/>}
                    { isDesktop &&  <AccountSummarySortableTableWithLinksWidget className="show-on-desktop" key="accountSummary_2"/>}
                  </React.Fragment>,
        // An option value in mabi23.
         "Account Summary sorted by Assets and Loans":
                  <React.Fragment key={ "account_summary_container" }>
                    {!isDesktop &&  <AccountSummaryAssetsAndLoansWidget key="accountSummary_1" className="show-on-mobile" view="mobile"/>}
                    { isDesktop &&  <AccountSummarySortableTableAssetsAndLoansWidget className="show-on-desktop" key="accountSummary_2"/>}
                  </React.Fragment>,

          "Alerts": <AlertsWidget />
      }

      if(optionMap("left_column_widget_1_abi22"))
      leftWidgets.push(mapLeftWidgets[optionMap("left_column_widget_1_abi22")]);
      if(optionMap("left_column_widget_2_abi22"))
      leftWidgets.push(mapLeftWidgets[optionMap("left_column_widget_2_abi22")]);
      if(optionMap("left_column_widget_3_abi22"))
      leftWidgets.push(mapLeftWidgets[optionMap("left_column_widget_3_abi22")]);
     
     
   let    rightWidgets = [];
  let mapRightWidgets = {
          "None":false,
          "Payments": <PaymentsWidget ui={ ui } key="pay_1"/>,
          "Credit Score":<CreditScoreWidget key="creditScore_1" dialDataPoint="Dial" scoreDataPoint="Score" updatedDataPoint="Updated" alertsDataPoint="Alerts" fullReportDataPoint="FullReport" ratingDataPoint="Rating" />, 
          "Quick Transfer" :<QuickTransferWidget key="quickTransfer_1"/>,
          "Ad":ad,
          "Ad 1": ad_1,
          "Ad 2": ad_2,
          "Quick Links":<QuickLinksWidget key="quickLinks_1"/>,
          "Manage Cards": <ManageCardsWidget key="card_2"/>,
          "Change Login": <ChangeLoginWidget key="changeLogin_2"/>
      }    
      if(optionMap("right_column_widget_1_abi22"))
      rightWidgets.push(mapRightWidgets[optionMap("right_column_widget_1_abi22")]);
      if(optionMap("right_column_widget_2_abi22"))
      rightWidgets.push(mapRightWidgets[optionMap("right_column_widget_2_abi22")]);
      if(optionMap("right_column_widget_3_abi22"))
      rightWidgets.push(mapRightWidgets[optionMap("right_column_widget_3_abi22")]);
      if(optionMap("right_column_widget_4_abi22"))
      rightWidgets.push(mapRightWidgets[optionMap("right_column_widget_4_abi22")]);
      if(optionMap("right_column_widget_5_abi22"))
      rightWidgets.push(mapRightWidgets[optionMap("right_column_widget_5_abi22")]);
     

      
  // END: Branding for MABI23.
//wait for mabiBranding to load 
useEffect(() => {
      // Detect window resize to apply desktop only options and mobile only options.
      const onWindowResize = () => setIsDesktop(window.innerWidth >= 751);
      window.addEventListener("resize", onWindowResize);
      onWindowResize();
      return () => window.removeEventListener("resize", onWindowResize);
    });
  if (Util.inMabi){
    if(!mabi23Branding){
       return <></>
    }   
  }
    

   return(   <PageContentView>
        { /**<CheckmarkBanner text="Preferences saved successfully." /> */}
        <LeftColumnContainer>
          {leftWidgets}    
        </LeftColumnContainer>
        <RightColumnContainer>
          {rightWidgets}       
        </RightColumnContainer>
      </PageContentView>
  );
}

export const getDefaultPageData = () => ({
  // no data for now
});

export const getDefaultPageUI = () => ({
  paymentsWidgeteBills: { isActive: false },
  paymentsWidgetPending: { isActive: false }
});

